(function () {'use strict';}());
angular.module("app").directive('headerView', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: 'views/header.html?version=1.0',
      replace: true,

      link:function($scope,element,attr) {
        var trace = angular.trace;
        var speed = 250;
        $scope.showMenu = false;
        $scope.fadeMenu = false;
        $scope.transitioning = false;


        $scope.toggle = function() {
        	var show = !$scope.showMenu;
        	$scope.transitioning = true;

        	if(show) {
        		$scope.showMenu = true;
        		$timeout(fadeMenu,speed);
        	} else {
        		$scope.fadeMenu = false;
        		$timeout(hideMenu,speed);
        	}
        	
        };

        function fadeMenu() {
        	$scope.fadeMenu = true;
        	$timeout(completeTransition,speed);
        }

        function hideMenu() {
        	$scope.showMenu = false;
        	$timeout(completeTransition,speed);
        }

        function completeTransition() {
        	$scope.transitioning = false;
        }
      }  
    };
  });